module.exports = __webpack_public_path__ + "img/twitter.65028d94.png";